import ZoomOut from '../../src/legacy/ZoomOut.tsx';
export default ZoomOut;
